import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import toastr from 'toastr';
import MnComboInline2 from "@mnjsplatform/components/lib/common/Dropdown/MnComboInline2";
import RequestScheduleVacationPrintPopup from "./RequestScheduleVacationPrintPopup";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";

class RequestScheduleVacationCreatePopup extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            printFormVisible: false,
            commentFormVisible: false,
            comment: null,
            closeForm: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {withStyle: true}));
            await this.props.dispatch(this.props.SchedHolidayTransfer_ButtonOnNotePO.reset());
            await this.props.dispatch(this.props.SchedHolidayTransfer_ButtonOnNotePO.initialize(this.props.rowKey));
            await this.props.dispatch(this.props.SchedHolidayTransfer_ScanPO.reset());
            await this.props.dispatch(this.props.SchedHolidayTransfer_ScanPO.initialize(this.props.rowKey));
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({inOperation: false});
        }
    }
    refreshButtons = async () => {
        return await this.props.dispatch(this.props.SchedHolidayTransfer_ButtonOnNotePO.execute(this.props.rowKey));
    }
    refreshDataItem = async () => {
        await this.props.dispatch(this.props.dataItem.refresh(this.props.rowKey));
        const rowKey = this.props.dataItem.getRowKeyByIndex(this.props.dataItem.rowInEditIndex);
        return await this.props.dispatch(this.props.SchedHolidayTransferMonth_ListPO_CheckOnUpd.execute(rowKey));
    }
    showToastr = (status, text, showProgress = false) => {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": showProgress,
            "positionClass": "toast-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "100",
            "hideDuration": "1000",
            "timeOut": "4000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
        switch (status) {
            case 'success': {
                toastr.success(text);
                break;
            }
            case 'error': {
                toastr.error(text);
                break;
            }
            case 'warning': {
                toastr.warning(text);
                break;
            }
            default: {
                toastr.info(text);
                break;
            }
        }
    }
    executeAction = async (row) => {
        let action = null;
        console.log(`row.ButtonId=${row.ButtonId}`);
        switch (row.ButtonId) {
            case 'Confirm':
                action = async () => {
                    await this.props.dispatch(this.props.SchedHolidayTransfer_ConfirmPO.execute(this.props.rowKey));
                    if (row.IsClose === 1) {
                        await this.onClose();
                    }
                };
                break;
            case 'Reject':
                action = () => this.setState({commentFormVisible: true, closeForm: row.IsClose === 1});
                break;
            case 'Sign':
                action = async () => {
                    await this.props.dispatch(this.props.SchedHolidayTransfer_SignPO.execute(this.props.rowKey));
                    if (row.IsClose === 1) {
                        await this.onClose();
                    }
                }
                break;
            case 'Delete':
                action = async () => {
                    await this.props.dispatch(this.props.SchedHolidayTransfer_DeletePO.execute(this.props.rowKey));
                    if (row.IsClose === 1) {
                        await this.onClose();
                    }
                }
                break;
            case 'Cancel':
                action = async () => {
                    await this.props.dispatch(this.props.SchedHolidayTransfer_CancelPO.execute(this.props.rowKey));
                    if (row.IsClose === 1) {
                        await this.onClose();
                    }
                }
                break;
            case 'Close':
                action = async () => {
                    if (row.IsClose === 1) {
                        await this.onClose();
                    }
                }
                break;
            case 'Print':
                action = () => this.setState({printFormVisible: true, closeForm: row.IsClose === 1});
                break;
            case 'Send':
                action = async () => {
                    await this.props.dispatch(this.props.SchedHolidayTransfer_SendPO.execute(this.props.rowKey));
                    if (row.IsClose === 1) {
                        await this.onClose();
                    }
                }
                break;
            default:
                break;
        }
        if (action) {
            await action();
        }
        await this.refreshButtons();
    }
    getButton = (row) => {
        return <button type="button" key={row.ButtonId} disabled={row.IsEnable !== 1}
                       className="btn btn-regular -goahead  ml1ex mb-2"
                       onClick={() => this.executeAction(row)}>{row.ButtonName}</button>
    }
    renderScanForm = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                    </React.Fragment>)
                })}

            </div>
        </div>)
    }
    renderButtons = () => {
        const rows = this.props.SchedHolidayTransfer_ButtonOnNotePO.rawData.DataTable;
        const scanRow = rows && rows.find(row => row.ButtonId === 'Scan');
        return (rows && <>
            {scanRow && <div className="inwhite card p-2 mx-3 mb-1">
                <ComplexParam dataItem={this.props.SchedHolidayTransfer_ScanPO} renderParams={this.renderScanForm}
                              readOnly={scanRow.IsEnable !== 1}
                              onEndEditField={async (rowIndex, fieldDescriptor) => {
                                  await this.props.dispatch(this.props.SchedHolidayTransfer_ScanPO.save(0));
                              }}/>
            </div>}
            <div className="modal-footer">
                {rows.map((row, index) => row.ButtonId !== 'Scan' && this.getButton(row))}
            </div>
        </>)
    }
    onClose = async () => {
        await this.props.dispatch(this.props.SchedHolidayTransfer_CheckOnClosePO.execute(this.props.rowKey));
        const message = this.props.SchedHolidayTransfer_CheckOnClosePO.getField(0, 'ErrorMessage');
        if (message)
            this.showToastr('error', message);
        if (this.props.onClose) {
            this.props.onClose(true);
        }
    }
    /*
        key: fieldIndex,
        row: this.props.row,
        rowIndex: this.props.rowIndex,
        fieldInfo: fieldInfo,
        fieldIndex: fieldIndex,
        dataItem: this.props.dataItem,
        readOnly: this.props.readOnly,
        cellAttributes: this.props.cellAttributes[fieldInfo.Name],
        customFieldExMap: this.props.customFieldExMap,
        rootPath: this.props.rootPath,
        updateStateFlag: this.props.updateStateFlag,
        cellStyleProvider: this.props.cellStyleProvider,
        renderCellDefault: this.renderCellDefault,
        enableCellLinesLimit: this.props.enableCellLinesLimit,
        cellLongTextMaxLength: this.props.cellLongTextMaxLength,
        pageHeaderHeight: this.props.pageHeaderHeight
    */
    renderCellEx = (cellParams) => {
        if (cellParams.row.ReadOnlyRow !== 1) {
            if (cellParams.fieldInfo.Name === 'NumMonthToStr') {
                return <MnComboInline2
                    parentDataItem={cellParams.dataItem}
                    fieldInfo={cellParams.fieldInfo}
                    allowReset={true}
                    rootPath={cellParams.dataItem.rootPath + "_" + cellParams.fieldInfo.Name}
                    rowIndex={cellParams.rowIndex}
                    readOnly={false}
                    onSelected={async () => {
                        const rowKey = cellParams.dataItem.getRowKeyByIndex(cellParams.rowIndex);
                        await this.props.dispatch(this.props.SchedHolidayTransferMonth_ListPO_CheckOnUpd.execute(rowKey));
                        await this.props.dispatch(cellParams.dataItem.save(cellParams.rowIndex));
                        await this.props.dispatch(cellParams.dataItem.refresh());
                    }}
                />
            }
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    gridCellStyleProvider = (dataItem, rowIndex, fieldInfo) => {
        const row = dataItem.getRow(rowIndex);
        if (row.ReadOnlyRow === 1) {
            return {backgroundColor: '#EEEEEE', textAlign: 'center'};
        } else {
            if (fieldInfo.Name === 'NumMonthToStr') {
                return {backgroundColor: '#4FC3F7', textAlign: 'center'};
            }
        }
        return {backgroundColor: '#EEEEEE', textAlign: 'center'};
    }
    headerStyleProvider = () => {
        return {textAlign: 'center'};
    }

    render() {
        return (<><PopupWrapper popupVisible={true}
                                title={i18next.t('Request_Schedule_Vacation')}
                                onClose={this.onClose} renderButtons={this.renderButtons}>
            <PlaceholderWrapper placeholderId="RequestScheduleVacationCreatePopup_10" canCollapse={false}
                                showSplitterLine={false} showHeaderTitle={false}
                                title={i18next.t("Edit_Request_Schedule_Vacation")}>
                <GridView dataItem={this.props.dataItem}
                          readOnly={true}
                          afterEditRow={this.refreshDataItem}
                          afterDeleteRow={this.refreshDataItem}
                          showHeader={true}
                          useItemStyle={true}
                          renderCellEx={this.renderCellEx}
                          cellStyleProvider={this.gridCellStyleProvider}
                          headerStyleProvider={this.headerStyleProvider}
                          overrideVisibility={{"NumMonthToStr": true}}
                />
            </PlaceholderWrapper>
        </PopupWrapper>
            {this.state.printFormVisible &&
                <RequestScheduleVacationPrintPopup
                    dataItem={this.props.dataItem}
                    rowKey={this.props.rowKey}
                    onClose={() => {
                        this.setState({printFormVisible: false}, async () => {
                            if (this.state.closeForm) {
                                await this.onClose();
                            }
                        });
                    }}
                />
            }
            {
                <PopupWrapper popupVisible={this.state.commentFormVisible} maxWidthBody="400px"
                              title={i18next.t("Manager_Comment")}
                              onClose={async () => {
                                  this.setState({commentFormVisible: false});
                                  const key = Object.assign({}, this.props.rowKey, {Comment: this.state.comment});
                                  await this.props.dispatch(this.props.SchedHolidayTransfer_RejectPO.execute(key));
                                  if (this.state.closeForm) {
                                      await this.onClose();
                                  }
                              }}>
                    <textarea className="w-100" value={this.state.comment}
                              onChange={(e) => this.setState({comment: e.target.value})}></textarea>
                </PopupWrapper>

            }
        </>)
    }
}

RequestScheduleVacationCreatePopup.propTypes = {
    dispatch: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    onClose: PropTypes.func,
    dataItem: PropTypes.object,
    rowKey: PropTypes.object,
    SchedHolidayTransfer_ButtonOnNotePO: PropTypes.object,
    SchedHolidayTransferMonth_ListPO_CheckOnUpd: PropTypes.object,
    SchedHolidayTransfer_SignPO: PropTypes.object,
    SchedHolidayTransfer_DeletePO: PropTypes.object,
    SchedHolidayTransfer_CancelPO: PropTypes.object,
    SchedHolidayTransfer_CheckOnClosePO: PropTypes.object,
    SchedHolidayTransfer_ScanPO: PropTypes.object,
    SchedHolidayTransfer_SendPO: PropTypes.object,
    SchedHolidayTransfer_ConfirmPO: PropTypes.object,
    SchedHolidayTransfer_RejectPO: PropTypes.object
}

RequestScheduleVacationCreatePopup.defaultProps = {
    readOnly: false
}

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.vacationState.SchedHolidayTransferMonth_ListPO,
        SchedHolidayTransfer_ButtonOnNotePO: state.vacationState.SchedHolidayTransfer_ButtonOnNotePO,
        SchedHolidayTransferMonth_ListPO_CheckOnUpd: state.vacationState.SchedHolidayTransferMonth_ListPO_CheckOnUpd,
        SchedHolidayTransfer_SignPO: state.vacationState.SchedHolidayTransfer_SignPO,
        SchedHolidayTransfer_DeletePO: state.vacationState.SchedHolidayTransfer_DeletePO,
        SchedHolidayTransfer_CancelPO: state.vacationState.SchedHolidayTransfer_CancelPO,
        SchedHolidayTransfer_CheckOnClosePO: state.vacationState.SchedHolidayTransfer_CheckOnClosePO,
        SchedHolidayTransfer_ScanPO: state.vacationState.SchedHolidayTransfer_ScanPO,
        SchedHolidayTransfer_SendPO: state.vacationState.SchedHolidayTransfer_SendPO,
        SchedHolidayTransfer_ConfirmPO: state.vacationState.SchedHolidayTransfer_ConfirmPO,
        SchedHolidayTransfer_RejectPO: state.vacationState.SchedHolidayTransfer_RejectPO
    }
}

export default connect(mapStateToProps)(RequestScheduleVacationCreatePopup)